import { func } from "prop-types";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { ReactComponent as Warning } from 'assets/images/svg/warning.svg';
import { ReactComponent as Download } from 'assets/images/svg/download.svg';
import { ReactComponent as Delete } from 'assets/images/svg/delete.svg';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { getBusinessList, patchBusinessList, setNewBusinessList } from "crud/auth.crud";

import _ from "lodash";
import moment from "moment";

// import images
import weaver from "../../assets/images/weaver.png";
import loading from "../../assets/images/loading.gif";

const BusinessListManagementScreen = () => {
  const history = useHistory()
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()

  const [dataList, setDataList] = useState([]);
  const [sumList, setSumList] = useState([]);
  const [priceList, setPriceList] = useState([]);
  const [pricePerL, setPricePerL] = useState(50);
  const [user, setUser] = useState(selector.auth?.user);
  const [company, setCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.id);
  const [startDate, setStartDate] = useState(moment(newDate).format('YYYY-MM') + '-01 00:00:00');
  const [endDate, setEndDate] = useState(moment(nextDate.setMonth(nextDate.getDate() + 1)).format('YYYY-MM') + '-01 00:00:00');
  const [modalShow, setModalShow] = useState(false);
  const [reset, setReset] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [size, setSize] = useState(4);
  const [totalElements, setTotalElements] = useState(4);
  const [page, setPage] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [companyListFile, setCompanyListFile] = useState([]);
  const [onUpload, setOnUpload] = useState(false);

  const getDataList = async () => {
    try {
      const response = await getBusinessList(`?id=${company}`);
      if (response.data?.result === 'success') {
        const dataList = response?.data?.data;
        setDataList(dataList.filter(item => item.id !== company))
      }
    } catch (error) {
      console.error(error);
    }
  }

  const deleteChildrenCompany = async (id) => {
    if (confirm("해당 사업장을 삭제하시겠습니까?")) {
      const params = { parents_company: null }
      await patchBusinessList(id, params)
      getDataList()
    }
  }

  // const deleteFile = () => {}

  const changeBusinessList = async () => {
    setOnUpload(true)

    try {
      const params = {
        type: 'xlsx',
        category: 'companyListFile',
        company_id: company,
        member_id: user.id
      }
      const fd = new FormData();
      fd.append('data', JSON.stringify(params));
      const newFile = new File([companyListFile[0]], `${encodeURI(companyListFile[0].name)}`, { type: companyListFile[0].type })
      if (companyListFile && !_.isEmpty(companyListFile)) {
        fd.append('file_0', newFile);
      }

      const response = await setNewBusinessList(fd)
      if (response.data?.result === 'success') {
        getDataList()
      }


    } catch (e) {
      console.log(e)
    }
    setOnUpload(false)
  }

  const registFiles = (e) => {
    setCompanyListFile([...e.target.files])
    // let filteredFiles
    // for(let i=0;i<e.target.files.length;i++){
    //   if(companyListFile?.length > 0 && companyListFile?.map(item => item.name).indexOf(e.target.files[i].name) != -1){
    //     filteredFiles = (filteredFiles || [...e.target.files]).filter(data => data !== [...e.target.files][i]);
    //   }
    // }
    // setCompanyListFile([...companyListFile || '', ...(filteredFiles || e.target.files)])
  }

  const deleteFile = (item) => {
    setCompanyListFile(companyListFile.filter(data => data !== item))
  }

  const fileDownload = async () => {
    let url = 'https://waveradmin.ropiklabs.com/media/sample/다수사업장등록엑셀.xlsx'
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const excelUrl = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = excelUrl;
        link.setAttribute('download', '다수사업장등록엑셀.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error(error)
      })
  };

  useEffect(() => {
    getDataList()
  }, [page])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>사업장 목록 관리 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="마이웨버" breadcrumbItem="사업장 목록 관리" />

          {!modalShow &&
            <Row>
              <Col xs={12} className="waver-pagination-btn-group mb-4 text-end" style={{maxWidth: '25.625rem'}}>
                <button className="waves-effect submit-btn btn btn-secondary zfont-size-16"
                  onClick={() => { setModalShow(true) }}>일괄등록</button>
              </Col>
            </Row>
          }

          <Row>
            <Col xs={12} style={{maxWidth: '25.625rem'}}>
              <div className="email-rightbar mb-3">
                <Card className="overflow-hidden">

                  {!modalShow &&
                    <div className="radius-4 overflow-hidden">
                      <div className="table-responsive">
                        <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                          <thead className="chart-thead">
                            <tr>
                              <th scope="col" >사업장명</th>
                              <th scope="col" >삭제</th>
                            </tr>
                          </thead>
                          <tbody className="chart-tbody">
                            {dataList && dataList.map((item, index) => {
                              return (
                                <tr key={item.id + '_' + index}>
                                  <td>{item.name}</td>
                                  <td><i className="mdi mdi-trash-can-outline font-size-18 pointer" onClick={() => {
                                    deleteChildrenCompany(item.id)
                                  }} /></td>
                                </tr>
                              )
                            })
                            }
                            {!dataList &&
                              <tr>
                                <td scope="row" colSpan="6">데이터가 없습니다.</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  }

                  {modalShow &&
                    <CardBody className="p-4">

                      <div className="download-container mt-2 d-flex flex-column justify-content-between" style={{ height: 'fit-content' }}>
                        <div className="d-flex align-items-top">
                          <Warning width={28} height={22} />
                          <p className="noMargin font-size-14 text-black padding-left-8">파일 업로드시, 기존 목록과 파일의 중복된 내용을 제외한 나머지 부분만 등록됩니다.  삭제는 개별 삭제 해주세요.</p>
                        </div>
                        <div className="waver-pagination-btn-group float-right d-flex justify-content-end">
                          <button className="waves-effect submit-btn btn btn-secondary font-size-14 mt-2"
                            onClick={() => {
                              fileDownload()
                            }}
                          >샘플 엑셀파일 다운로드<Download className="margin-left-8" />
                          </button>
                        </div>
                      </div>

                      <label style={{ padding: '0.4rem 1rem', borderRadius: '0.2rem', margin: "18px 0", fontSize: 16 }} htmlFor="ex_file" className="btn btn-primary dropdown-toggle waves-effect waves-light">파일선택
                      </label>
                      <input style={{ display: "none" }} type="file" accept=".xls,.xlsx" id="ex_file" onChange={(e) => {
                        registFiles(e)
                      }} />

                      {companyListFile.length > 0 && companyListFile.map((item, index) => {
                        return (
                          <div className="file-confirm" key={index}>
                            <p className="noMargin">{item.name}</p>
                            <Delete className="margin-left-8 pointer" onClick={() => { deleteFile(item) }} />
                          </div>
                        )
                      })}

                      <div className="d-flex mt-4 justify-content-end">
                        <button className="waves-effect btn btn-silver font-size-16" onClick={() => {
                          setModalShow(false)
                        }}>취소</button>
                        <button className="waves-effect btn btn-primary font-size-16" onClick={async () => {
                          await changeBusinessList()
                        }}>등록하기</button>
                      </div>

                    </CardBody>
                  }

                  {onUpload && <div style={{
                    position: "absolute",
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    background: 'rgba(255, 255, 255, 0.6)',
                    zIndex: 999,
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img src={loading} alt="로딩중입니다." width={'5%'}></img>
                  </div>}

                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BusinessListManagementScreen